import FlagForm, {ACCOUNT_SCOPE} from './FlagForm'
import Modal from '../../shared/Modal'

import {connect} from '../../../state/hooks/tools'
import {createResource} from '../../../lib/asyncMethods'
import {fullName} from '../../../lib/tools'
import {SETTINGS} from '../../../state/actionTypes'

const NewFlag = props => {
  /**
   * The account field keeps whatever was picked before the scope was moved back to everyone, so the
   * scope decides whether it reaches the payload at all rather than the field being cleared.
   */
  const handleSubmit = ({scope, ownableId, ...attributes}) => {
    props.createResource({
      endpoint: 'settings',
      attributes: {...attributes, featureFlag: true, ...(scope === ACCOUNT_SCOPE && {ownableId})}
    }).then(response => {
      if (response.success)
        props.toggleModal()
    })
  }

  return (
    <Modal
      open={props.showModal}
      handleClose={props.toggleModal}
      disabled={props.loading}
      maxWidth='sm'
      buttonText='Done'
      subHeading='A named switch the code reads. Scope it to one account, or leave it open to everyone.'
      title='New Flag'>
        <FlagForm
          accounts={props.accounts}
          handleSubmit={handleSubmit}
          loading={props.loading}
        />
    </Modal>
  )
}

const mapStateToProps = ({metadata, users}) => ({
  accounts: (users.users || []).map(user => ({label: fullName(user), value: user.id})),
  loading: metadata.loading
})

const actionCreators = ({metadata}) => ({createResource: createResource(metadata, SETTINGS)})

export default connect(mapStateToProps, actionCreators)(NewFlag)
